export const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    fill="none"
    viewBox="0 0 10 12"
  >
    <path
      fill="#1B9C85"
      d="M1 7.732c-1.333-.77-1.333-2.694 0-3.464L7 .804c1.333-.77 3 .192 3 1.732v6.928c0 1.54-1.667 2.502-3 1.732z"
    ></path>
  </svg>
);

export function ShowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#1B9C85"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M15.58 12c0 1.98-1.6 3.58-3.58 3.58S8.42 13.98 8.42 12s1.6-3.58 3.58-3.58 3.58 1.6 3.58 3.58z"
      ></path>
      <path
        stroke="#1B9C85"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M12 20.27c3.53 0 6.82-2.08 9.11-5.68.9-1.41.9-3.78 0-5.19-2.29-3.6-5.58-5.68-9.11-5.68-3.53 0-6.82 2.08-9.11 5.68-.9 1.41-.9 3.78 0 5.19 2.29 3.6 5.58 5.68 9.11 5.68z"
      ></path>
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#EE4E4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21 5.98c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3L3 5.98M8.5 4.97l.22-1.31C8.88 2.71 9 2 10.69 2h2.62c1.69 0 1.82.75 1.97 1.67l.22 1.3M18.85 9.14l-.65 10.07C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5h3.33M9.5 12.5h5"
      ></path>
    </svg>
  );
}

export const FileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#808487"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M4.853 10 3.566 8.713a3.64 3.64 0 1 1 5.147-5.147l7.721 7.72a3.64 3.64 0 0 1-5.147 5.148l-2.895-2.895a2.275 2.275 0 0 1 3.217-3.217l1.608 1.608"
    ></path>
  </svg>
);